import styled from '@emotion/styled';
import { pxToRem } from '../../../../styles/utils';
import { Flexbox } from '../../../Flexbox';
import { mediaQueries } from '../../../../styles/media-queries';
import {
  LinearGradientToken,
  useLinearGradientColorProp
} from '../../../../theme/tokens/linear-gradient';
import Link from '../../../Link';

interface CategoryTileWrapperProps {
  color: LinearGradientToken;
}

export const TilesSectionWrapper = styled(Flexbox)`
  width: 100%;
  gap: ${pxToRem(8)};
`;

export const CategoryTileWrapper = styled('div')<CategoryTileWrapperProps>`
  border-radius: ${pxToRem(24)};
  width: 100%;
  max-width: ${pxToRem(192)};
  height: ${pxToRem(269)};
  transition:
    transform 0.2s ease,
    height 0.2s ease,
    margin 0.2s ease,
    box-shadow 0.2s ease;
  will-change: transform, margin, box-shadow;
  ${useLinearGradientColorProp}

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 8px 25px 0 rgba(29, 37, 44, 0.16);
  }

  ${mediaQueries.desktop} {
    max-width: none;
    height: ${pxToRem(280)};
    font-size: ${pxToRem(26)};
    position: relative;

    &:hover {
      &:has(*) {
        margin-left: 0;
        margin-right: 0;
      }
      transform: scale(1.11);
    }
  }
`;

export const CategoryLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-content: start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: ${({ theme }) => theme.spacing.m};
  color: white;
  font-size: ${pxToRem(22)};
  font-weight: 400;
  text-transform: capitalize;

  > span {
    width: ${pxToRem(64)} !important;
  }

  ${mediaQueries.desktop} {
    font-weight: 300;
  }
`;

export const Title = styled('div')`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;
